<div class="hub-checkbox-container" [class]="checkboxClass" [ngClass]="{'disabled' : disabled}" (click)="clicked($event)">
    <span class="hub-checkbox-base" class="hub-checkbox-base" [ngClass]="{
            checked: value, 
            disabled: disabled
        }" [attr.aria-checked]="value" [attr.aria-disabled]="disabled" role="checkbox" tabindex="0"
        (keydown.space)="clicked($event)" (keydown.enter)="clicked($event)">
        <daz-icon [name]="'check'" [color]="'#ffffff'" [size]="'18px'" *ngIf="value"></daz-icon>
    </span>
    <div>
        <div class="hub-checkbox-label">{{ label }}</div>
        <div class="hub-checkbox-label-extra" *ngIf="labelExtra">{{ labelExtra }}</div>
    </div>
</div>